import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useFormikContext } from "formik";

import {
  CftLayout,
  CftHeader,
  CftSection,
  CftFooter,
  CftActionsButtons,
  CftReportProgress,
  CftExportReport,
} from "../../components";
import routes from "../../utils/cftRoutes";
import { useCft } from "../../utils/CftProvider";
import TransporDPForm, {
  TransporDPFormContext,
} from "../../forms/dairyProduction/TransporDPForm/TransporDP.form";

function TransportDairyProductionPage() {
  const { t } = useTranslation(["cft"]);
  const history = useHistory();
  const { saveDairyProduction } = useCft();
  const { submitForm, values, isSubmitting } = useFormikContext();

  return (
    <CftLayout
      header={
        <CftHeader
          progressValue={88}
          cropName={t("cft:types.dairyProduction", "Produkcja mleczarska")}
          actions={
            <div
              style={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
              }}
            >
              <CftActionsButtons.CancelButton
                onClick={() => {
                  saveDairyProduction({
                    transport: values,
                  });
                  history.push(routes.DAIRY_PRODUCTION.MAIN);
                }}
              />
              <CftExportReport type="dairyProduction" />
            </div>
          }
        />
      }
      footer={
        <CftFooter
          isPending={isSubmitting}
          text={t("cft:transport.title", "Transport")}
          onBack={() =>
            history.push(routes.DAIRY_PRODUCTION.ENERGY_AND_PROCESSING)
          }
          onNext={submitForm}
          nextText={t("cft:report.btn", "Wygeneruj raport")}
        />
      }
    >
      <CftSection
        header={
          <>
            <h3>{t("cft:transport.title", "Transport")}</h3>
            <p>
              {t(
                "cft:transport.subtitle",
                "Należy uwzględnić transport przychodzący środków produkcji - takich jak pasze z młyna lub nawozy od sprzedawcy - do gospodarstwa. Dobrą praktyką jest uwzględnienie również transportu wychodzącego gotowych produktów do miejsca przetwarzania."
              )}
            </p>
          </>
        }
      >
        <TransporDPForm />
        <CftReportProgress type="dairyProduction" />
      </CftSection>
    </CftLayout>
  );
}

export default () => {
  return (
    <TransporDPFormContext>
      <TransportDairyProductionPage />
    </TransporDPFormContext>
  );
};
